var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelSms = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M4.5 7.08c0-.925.752-1.677 1.677-1.677h11.646c.925 0 1.677.752 1.677 1.676v6.156c0 .925-.752 1.677-1.677 1.677H9.017L4.5 18.597zm1.947-.294a.696.696 0 0 0-.695.695v8.324q2.453-1.994 2.627-2.166c.175-.173.347-.269.68-.269h8.399a.696.696 0 0 0 .695-.695V7.48a.696.696 0 0 0-.695-.695z"
})));
export default SvgChannelSms;